import queryString from 'query-string';

const helper = (route, params = {}) => {
  const query = queryString.stringify(params);

  return `${route}${query.length > 0 ? `?${query}` : ''}`;
};

const elementaryMultiPose = (route, params = {}) => helper(`/elementary-multi-pose${route}`, params);
const landing = (route, params = {}) => helper(`/landing${route}`, params);
const seniorPortraits = (route, params = {}) => helper(`/senior-portraits${route}`, params);
const promos = (route, params = {}) => helper(`/promos${route}`, params);
const seniors = (route, params = {}) => helper(`/seniors${route}`, params);
const holiday = (route, params = {}) => helper(`/gifts${route}`, params);
const pastImages = (route, params = {}) => helper(`/past-images${route}`, params);
const limitedPoses = (route, params = {}) => helper(`/limited${route}`, params);

export const routes = {
  appointmentOptionSelection: (packageId, params = {}) => helper(`/appointment-session-selection/${packageId}`, params),
  appointmentSelection: (params = {}) => helper('/appointment-selection', params),
  appointmentReview: (params = {}) => helper('/appointment-review', params),
  backgroundSelection: (packageId, params = {}) => helper(`/background_selection/${packageId}`, params),
  cart: (params = {}) => helper('/cart', params),
  checkout: (params = {}) => helper('/checkout', params),
  downloadImage: (orderId, email, params = {}) => helper(`/download-image/orderId/${orderId}/email/${email}`, params),
  downloadImageForm: (params = {}) => helper('/download-image', params),
  earlyPurchase: (params = {}) => helper('/early-purchase', params),
  elementaryMultiPoseBuilder: (packageId, params = {}) => elementaryMultiPose(`/builder/${packageId}`, params),
  favoritePoseSelection: (packageId, params = {}) => seniorPortraits(`/favorite-pose-selection/${packageId}`, params),
  frequentlyAskedQuestions: () => '/frequently-asked-questions',
  holiday: {
    builder: (params = {}) => holiday('/builder', params),
    edit: (orderPackageId, params = {}) => holiday(`/edit/${orderPackageId}`, params),
  },
  home: (params = {}) => helper('/', params),
  mobileUpload: (params = {}) => helper('/mobile-upload', params),
  multiPoseReview: (orderPackageId, params = {}) => elementaryMultiPose(`/review/${orderPackageId}`, params),
  optionSelection: (packageId, params = {}) => helper(`/option_selection/${packageId}`, params),
  packageBuilder: (packageId, params = {}) => seniorPortraits(`/package-builder/${packageId}`, params),
  packageSelection: (params = {}) => helper('/package_selection', params),
  panorama: (params = {}) => landing('/panorama', params),
  promos: (packageId, params = {}) => helper(`/promos/${packageId}`, params),
  review: (params = {}) => helper('/review', params),
  scheduleAtShoob: (params = {}) => helper('/schedule-at-shoob', params),
  scheduleAppointment: (params = {}) => helper('/schedule-appointment', params),
  seniorAddons: (params = {}) => seniorPortraits('/addons', params),
  seniorOptionSelection: (packageId, params = {}) => seniorPortraits(`/option-selection/${packageId}`, params),
  seniorPortraitReview: (orderPackageId, params = {}) => seniorPortraits(`/review/${orderPackageId}`, params),
  sittings: (params = {}) => helper('/sittings', params),
  studentIdEntry: (params = {}) => helper('/student_id_entry', params),
  yearbookPromos: (params = {}) => promos('/yearbooks', params),
  yearbooks: (params = {}) => landing('/yearbooks', params),
  composites: (params = {}) => landing('/composites', params),
  multiPoseAddons: (params = {}) => elementaryMultiPose('/addons', params),
  multiPoseEdit: (orderPackageId, params = {}) => elementaryMultiPose(`/${orderPackageId}/edit`, params),
  individualPrintEdit: (orderPackageId, params = {}) => elementaryMultiPose(`/individual-prints/${orderPackageId}/edit`, params),
  addons: (orderPackageId, params = {}) => elementaryMultiPose(`/addons/${orderPackageId}/add`, params),
  getAccessCode: (params = {}) => helper('/get-access-code', params),
  orderStatus: (params = {}) => helper('/order-status', params),
  registration: (params = {}) => helper('/register', params),
  sheetBackgroundSelection: (orderId, params = {}) => landing(`/background-selection/${orderId}`, params),
  teacherSignup: (params = {}) => helper('/teachers/sign_up', params),
  teacherLoginCode: (params = {}) => helper('/teachers/login_from_code', params),
  packageLanding: (packageId, params = {}) => landing(`/package/${packageId}`, params),
  showcase: (params) => helper('/showcase', params),
  retouching: (orderPackageId, params = {}) => elementaryMultiPose(`/${orderPackageId}/retouching`, params),
  promotions: (optionId, params = {}) => helper(`/promotions/${optionId}`, params),
  landing: {
    holiday: (params = {}) => landing('/holiday', params),
    offer: (params = {}) => landing('/offer', params),
  },
  seniors: {
    addons: (orderPackageId, params = {}) => seniors(`/addons/${orderPackageId}/add`, params),
    packageBuilder: (packageId, params = {}) => seniors(`/builder/${packageId}`, params),
    individualPrintsEdit: (orderPackageId, params = {}) => seniors(`/individual-prints/${orderPackageId}`, params),
  },
  retakes: {
    home: (params = {}) => helper('/retakes', params),
    confirmation: (params = {}) => helper('/retakes/confirmation', params),
  },
  pastImages: {
    builder: (packageId, params = {}) => pastImages(`/builder/${packageId}`, params),
  },
  confirm: (orderPackageId, params = {}) => helper(`/confirm/${orderPackageId}`, params),
  testCheckout: (params = {}) => helper('/test-checkout', params),
  testCheckoutComplete: (params = {}) => helper('/test-checkout/complete', params),
};

export default routes;
